import React, { useEffect, useState } from 'react'
import { Alert, Card, CardBody, CardHeader, Col, Row } from 'reactstrap';
import { Checkbox, Textbox } from "react-inputs-validation";
import { apiPost } from '../../api';
import { urlGuardarRenovacion } from '../../constants/urls';


const EsRenovacion = ({
    esRenovacion = true,
    setEsRenovacion,
    numPolizaVence,
    setNumPolizaVence,
    tieneError,
    setTieneError
}) => {




    useEffect(() => {


    }, [])


    return (
        <Card>
            <CardBody>
                <Row>
                    <Col lg={10} md={6} sm={6} xs={12}>
                        <h5 style={{ fontWeight: "bold" }}>
                            Es renovación?
                        </h5>
                    </Col>
                    <Col lg={1} md={6} sm={6} xs={12}>
                        <Checkbox
                            id={"agreement"} // Optional.[String].Default: "".  Input ID.
                            name={"agreement"} // Optional.[String].Default: "". Input name
                            classNameInputBox={'check-uber-light'}
                            value={esRenovacion} // Required.[String].Default: "".
                            onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                            checked={esRenovacion} // Required.[Bool].Default: false.
                            onChange={(esRenovacion, e) => {

                                setEsRenovacion(esRenovacion)



                                //console.log(e);
                            }} // Required.[Func].Default: () => {}. Will return the value.
                            validationOption={{
                                name: "agreement", // Optional.[String].Default: "". To display in the Error message. i.e Please check the .
                                check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                            }}
                        />
                    </Col>


                </Row>

                {
                    esRenovacion &&
                    <Row>
                        <Col lg={6} md={6} sm={6} xs={12}>
                            <h5 style={{ fontWeight: "bold" }}>
                                Número de póliza que vence
                            </h5>
                        </Col>
                        <Col lg={6} md={6} sm={6} xs={12}>
                            <Textbox
                                tabIndex="1"
                                type={'number'}
                                disabled={
                                    false
                                }
                                value={numPolizaVence}
                                name={'numeroPoliza'}
                                id={'numeroPoliza'}
                                classNameInput={"form-control"}
                                placeholder={'Ingrese el número de póliza'}
                                onChange={(valor, e) => {
                                    setNumPolizaVence(valor)
                                }}
                                onBlur={e => {
                                    //this.setState({ blur: true });
                                    //console.log("BLUUUR");
                                }}
                                validate={tieneError}
                                validationCallback={res => {
                                    setTieneError(res)

                                }} // Optional.[Func].Default: none. Return the validation result.
                                validationOption={{
                                    type: 'number',
                                    required: true,
                                    reg: null,
                                    min: 0,
                                    max: 100000000000000,
                                    //  type: "number", // Optional.[String].Default: "string". Validation type, options are ['string', 'number', 'alphanumeric', 'alpha']
                                    // reg: /^[0-9]+(\.[0-9]+)?$/, //Optional.[Bool].Default: "" Custom regex.
                                    msgOnError: 'Ingrese un número de póliza válido',


                                }}



                            />


                        </Col>
                    </Row>
                }


      



            </CardBody>
        </Card>
    )
}

export const guardarRenovacion = async (esRenovacion, idCarrito, numPolizaVence) => {

    let param = {
        empresa: "AIGMETROPOLITANA",
        plataforma: "WEB",
        idCarrito: idCarrito,
        esRenovacion, esRenovacion,
        numPolizaVence: numPolizaVence
    }
    try {
        let res = await apiPost(urlGuardarRenovacion, param)
        if (res.transaccion) {

        }
    } catch (e) {
        alert('Ha ocurrido un error por favor intentar nuevamente')
    }

}

export default EsRenovacion;